module.exports = __webpack_public_path__ + "static/media/kg.05ee6fc3.svg";